export default {
	info: 'Bilgi',
	'select-store': 'Mağaza Seçin',
	'are-you-sure-you-want-to-logout': 'Oturum kapatmak emin misiniz?',
	menu: {
		logout: 'Çıkış'
	},
	pages: {
		stores: 'Mağazalar',
		'store-info': 'Mağaza bilgisi',
		'store-cashboxes': 'Mağaza kasaları',
		units: 'Birimler',
		users: 'Kullanıcılar',
	}
}